import React from "react";
import { Crown, Award, Clock } from "lucide-react";
import AIFitScoreBadge from "./AIFitScoreBadge";
import ApplesBadge from "./ApplesBadge";

export default function BidLeaderboard({ bids = [], onAccept, canAccept }) {
  const sorted = [...bids].sort((a, b) => (b.ai_score || 0) - (a.ai_score || 0));
  if (sorted.length === 0) {
    return (
      <div className="border border-[#262626] rounded-xl p-10 text-center text-[#737373]" data-testid="bids-empty">
        No bids yet. The DMC network is reviewing.
      </div>
    );
  }
  return (
    <div className="bg-[#0a0a0a] border border-[#262626] rounded-xl divide-y divide-[#1a1a1a]" data-testid="bid-leaderboard">
      {sorted.map((b, idx) => (
        <div
          key={b.bid_id}
          className={`p-5 md:p-6 flex flex-col md:flex-row md:items-center justify-between gap-4 transition-colors ${
            idx === 0 ? "border-l-2 border-l-brand pulse-brand" : "hover:bg-[#0f0f0f]"
          }`}
          data-testid={idx === 0 ? "top-bid-item" : `bid-item-${b.bid_id}`}
        >
          <div className="flex items-start gap-4">
            <div className="flex flex-col items-center w-10">
              <span className="font-mono text-2xl font-bold text-white">{idx + 1}</span>
              {idx === 0 && <Crown className="w-4 h-4 text-brand mt-1" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className="font-display font-bold text-white text-lg">{b.dmc_name}</h3>
                {b.dmc_premium && (
                  <span className="overline text-brand flex items-center gap-1">
                    <Award className="w-3 h-3" /> Premium
                  </span>
                )}
                {b.status === "accepted" && (
                  <span className="text-xs font-mono uppercase text-green-400 border border-green-400/30 px-2 py-0.5 rounded">
                    Accepted
                  </span>
                )}
              </div>
              <p className="text-sm text-[#a3a3a3] mt-1">
                {b.dmc_country || "—"} · Delivery in {b.timeline_days}d
              </p>
              <p className="text-sm text-[#737373] mt-2 line-clamp-2">{b.inclusions}</p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <div className="text-right">
              <p className="overline">Bid</p>
              <p className="font-mono text-2xl font-bold text-white">${Number(b.amount_usd).toLocaleString()}</p>
            </div>
            <ApplesBadge bid={b} compact />
            <AIFitScoreBadge score={b.ai_score} label="AI" />
            {canAccept && b.status === "pending" && (
              <button
                onClick={() => onAccept?.(b)}
                className="btn-primary text-sm"
                data-testid={`accept-bid-${b.bid_id}`}
              >
                Accept
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
